import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'RegistrationVerifyEmailController',
            RegistrationVerifyEmailController
        );

    /** @ngInject */
    function RegistrationVerifyEmailController(
        $stateParams,
        $state,
        UsersFactory,
        toastr
    ) {
        var data = {
            key: $stateParams.token,
        };

        UsersFactory.verifyEmail(data).then(
            function () {
                toastr.success(
                    'Konto zostało aktywowane, możesz się zalogować.'
                );
                $state.go('login');
            },
            function () {
                $state.go('login');
                toastr.error(
                    'Błędny link aktywacyjny. Skontaktuj się z administracją serwisu.'
                );
            }
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/registration/verify_email/verify_email.controller.ts